module.exports = __webpack_public_path__ + "static/blogs-banner-right-35a036acf5fd35a4dd87d4d24f056acf.svg";